export default "__VITE_ASSET__DmuVTZCF__"